import Logo, {LogoWithText} from './Logo';
import './Logo.scss';
export default Logo;
export {
	LogoWithText
}
